<template>
  <div class="font-weight-bold mb-2">
    <slot></slot>
  </div>
</template>

<style scoped>
div {
  font-size: 16px;
}
</style>
